import { Box, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { AccessGroupInfos, AccessUserInfos } from "../../../Core/Api/Types/access-models";
import { GroupedUserBasicInfos } from "../../../Core/Api/Types/grouped-user-basic-infos";
import { userService } from "../../../Core/Api/services";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import UserAccessAccordion from "../../Access/UserAccess/user-access-accordion";
import { IPreviewTabContentProps } from "./preview-tabs";
import ExternalAccessAccordion from "../../Access/ExternalAccess/external-access-accordion";
import { UserHasAcl } from "../../../Utils/helpers";
import { AclTypes } from "../../../Core/Api/Types/acl-types";
import { useTranslation } from "react-i18next";

function GetUserAndGroupInfosFromGroupedUserBasicInfos(groupedUsers: GroupedUserBasicInfos[]): {
  userInfos: AccessUserInfos[];
  groupInfos: AccessGroupInfos[];
} {
  const userInfos: AccessUserInfos[] = [];
  const groupInfos: AccessGroupInfos[] = [];

  groupedUsers.forEach((groupedUser) => {
    if (groupedUser.users) {
      groupedUser.users.forEach((user) => {
        if (user)
          userInfos.push({
            id: user.id,
            groupId: user.groupId,
            firstName: user.firstName!,
            lastName: user.lastName!,
          });
      });
    }

    if (groupedUser.group) {
      groupInfos.push({
        id: groupedUser.group.id,
        name: groupedUser.group.name!,
        count: groupedUser.users?.length || 0,
      });
    }
  });

  return { userInfos, groupInfos };
}

const AccessTab = (props: IPreviewTabContentProps) => {
  const { t } = useTranslation();
  const { asset } = props;

  const enqueueSnackbar = useCustomSnackbar();

  const userCanViewAccess = UserHasAcl(AclTypes.aclExternalAccessView);

  const [isLoading, setIsLoading] = React.useState(true);

  const [allUserInfos, setAllUserInfos] = React.useState<AccessUserInfos[]>([]);
  const [allGroupInfos, setAllGroupInfos] = React.useState<AccessGroupInfos[]>([]);

  useEffect(() => {
    userService.GetUsersBasicList().then((response) => {
      if (!response.success) {
        enqueueSnackbar(response.message || t("alert:error.oopsSomethingWentWrongWithDot"), "error");
      } else if (!response.groupedUsers) {
        enqueueSnackbar(t("alert:error.noGroupsFound"), "error");
      } else {
        const { userInfos, groupInfos } = GetUserAndGroupInfosFromGroupedUserBasicInfos(response.groupedUsers);
        setAllUserInfos(userInfos);
        setAllGroupInfos(groupInfos);
        setIsLoading(false);
      }
    });
  }, []);

  return (
    <Box py={2} px={3}>
      <Stack spacing={2}>
        <UserAccessAccordion
          asset={asset}
          allUserInfos={allUserInfos}
          allGroupInfos={allGroupInfos}
          isParentLoading={isLoading}
        />
        {userCanViewAccess && (
          <ExternalAccessAccordion asset={asset} allUserInfos={allUserInfos} isParentLoading={isLoading} />
        )}
      </Stack>
    </Box>
  );
};

export default AccessTab;
